module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Light.237ddbe.eot";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.eot
// module id = hmPg
// module chunks = 16